import { render } from "./SlipForm.vue?vue&type=template&id=720f09ac&scoped=true"
import script from "./SlipForm.vue?vue&type=script&lang=js"
export * from "./SlipForm.vue?vue&type=script&lang=js"

import "./SlipForm.vue?vue&type=style&index=0&id=720f09ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720f09ac"]])

export default __exports__